export const handleOnlyNumber = (e: any, setOnlyDigitError: (error: boolean) => void) => {
  const inputValue = e.data;
  const newValue = inputValue.toUpperCase(); // Change the value to uppercase

  // Check if the input value contains any non-numeric characters
  if (!/^\d/.test(newValue)) {
    e.preventDefault();
    setOnlyDigitError(true); // Prevent the update
    return;
  } else {
    setOnlyDigitError(false);
  }
};
